import script from "./jewel_key_legend.vue?vue&type=script&setup=true&lang=js"
export * from "./jewel_key_legend.vue?vue&type=script&setup=true&lang=js"

import "./jewel_key_legend.vue?vue&type=style&index=0&id=7e1e8ad5&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e1e8ad5"]])

export default __exports__